import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import Icon from '../../../components/AppIcon';

const AnalysisOptionsDialog = ({ isOpen, onClose, onSignIn, onTrial, photoCount }) => {
  if (!isOpen) return null;

  const isTrialEligible = photoCount <= 3;

  return (
    <AnimatePresence>
      {isOpen && (
        <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
          {/* Backdrop */}
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            onClick={onClose}
            className="absolute inset-0 bg-black/50 backdrop-blur-sm"
          />

          {/* Dialog */}
          <motion.div
            initial={{ opacity: 0, scale: 0.9, y: 20 }}
            animate={{ opacity: 1, scale: 1, y: 0 }}
            exit={{ opacity: 0, scale: 0.9, y: 20 }}
            transition={{ type: 'spring', damping: 25, stiffness: 300 }}
            className="relative bg-white rounded-3xl shadow-2xl w-full max-w-sm p-6 z-10"
          >
            {/* Icon */}
            <div className="flex justify-center mb-4">
              <div className="w-16 h-16 rounded-2xl bg-gradient-to-br from-purple-100 to-blue-100 flex items-center justify-center">
                <Icon name="Sparkles" size={32} className="text-purple-600" />
              </div>
            </div>

            {/* Title */}
            <h2 className="text-xl font-bold text-gray-900 text-center mb-2">
              Ready to Analyze?
            </h2>
            <p className="text-sm text-gray-500 text-center mb-6">
              Sign in to save your results and track your history, or try a free one-time comparison.
            </p>

            {/* Options */}
            <div className="space-y-3">
              {/* Sign In */}
              <button
                onClick={onSignIn}
                className="w-full py-3.5 px-4 rounded-2xl bg-gradient-to-r from-purple-600 to-blue-600 text-white font-semibold text-sm hover:from-purple-700 hover:to-blue-700 transition-all shadow-lg hover:shadow-xl flex items-center justify-center gap-2"
              >
                <Icon name="LogIn" size={18} />
                Sign in
              </button>

              {/* Continue with Trial */}
              <button
                onClick={isTrialEligible ? onTrial : undefined}
                disabled={!isTrialEligible}
                className={`w-full py-3.5 px-4 rounded-2xl font-semibold text-sm transition-all flex flex-col items-center justify-center gap-0.5 border-2 ${
                  isTrialEligible
                    ? 'border-purple-200 text-purple-700 bg-purple-50 hover:bg-purple-100 hover:border-purple-300' :'border-gray-200 text-gray-400 bg-gray-50 cursor-not-allowed'
                }`}
              >
                <span className="flex items-center gap-2">
                  <Icon name="Zap" size={18} />
                  Continue with trial
                </span>
                {isTrialEligible ? (
                  <span className="text-xs font-normal text-purple-500">
                    Free · up to 3 photos · no data saved
                  </span>
                ) : (
                  <span className="text-xs font-normal text-gray-400">
                    Trial limited to 3 photos — please remove {photoCount - 3} photo{photoCount - 3 !== 1 ? 's' : ''}
                  </span>
                )}
              </button>

              {/* Cancel */}
              <button
                onClick={onClose}
                className="w-full py-3 px-4 rounded-2xl text-gray-500 font-medium text-sm hover:bg-gray-100 transition-all"
              >
                Cancel
              </button>
            </div>
          </motion.div>
        </div>
      )}
    </AnimatePresence>
  );
};

export default AnalysisOptionsDialog;
